import React from 'react';
import { useParams } from 'react-router-dom';
import { Container, Typography, Grid, Card, CardMedia } from '@mui/material';
import juninaImg from '../assets/junina.jpg';
import obrImg from '../assets/obr.jpg';
import noitaroImg from '../assets/noitaro.jpeg';

const eventPhotos = {
  1: [noitaroImg],
  2: [juninaImg],
  3: [obrImg],
};

const eventNames = {
  1: 'Eco Tec',
  2: 'Festa Junina',
  3: 'Olimpíada de Informática',
};

const EventPhotos = () => {
  const { id } = useParams();
  const photos = eventPhotos[id] || [];
  const eventName = eventNames[id] || 'Evento';

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Fotos do Evento: {eventName}
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {photos.length > 0 ? (
          photos.map((img, idx) => (
            <Grid item xs={12} sm={6} md={4} key={idx}>
              <Card>
                <CardMedia
                  component="img"
                  height="220"
                  image={img}
                  alt={`Foto ${idx + 1}`}
                  sx={{ objectFit: 'cover' }}
                />
              </Card>
            </Grid>
          ))
        ) : (
          <Typography variant="body1" align="center" sx={{ width: '100%' }}>
            Nenhuma foto cadastrada para este evento.
          </Typography>
        )}
      </Grid>
    </Container>
  );
};

export default EventPhotos;
